import { useContext } from "react";
import toast from "react-hot-toast";
import { Grid } from "@mui/material";
import styles from "./styles.module.css";
import { useLongPress } from "../../hooks/useLongPress";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { formatName } from "../formatName";
import { roundOff, quantityRoundOff } from "helpers/NumberFormatHelper";
import { MEASURMENT_UNITS, DEFAULT_PRODUCT_IMAGE, PRODUCT_TYPE } from "const";
import ShopContext from "context/ShopContext";
import * as TerminalHelper from "helpers/TermialHelper";
import ProductPlaceholder from "images/product-placeholder.png";
import ProductContext from "context/ProductContext";
import SalesContext from "context/SalesContext";
import CartHelper from "helpers/CartHelper";
import * as SalesHelper from "helpers/SalesHelper";

function ItemView({ item, onAction, productView = false, isInCart = false }) {
  const { selectedShop } = useContext(ShopContext);
  const { selectedPriceCategory, activeSale } = useContext(SalesContext);
  const { priceCategoryItems } = useContext(ProductContext);

  const terminalSettings = TerminalHelper.getTerminalSettings();
  const allowNegativeStock = terminalSettings?.preventNegativeStock === "allow_negative_stock";

  const displayPrice = (() => {
    const activePriceCategory = SalesHelper.getActiveSalePriceCategory(activeSale, selectedPriceCategory);

    if (activePriceCategory) {
      return CartHelper.getApplicableCategoryPrice(item.id, 1, activePriceCategory, priceCategoryItems) ?? item.price;
    }
    return item.price;
  })();

  const isOutOfStock = item?.type === PRODUCT_TYPE.SERVICE ? false : (item?.stock ?? 0) <= 0;
  const { wasLongPress, ...longPressEvents } = useLongPress(() => onAction(item, "details"), 500);

  const handleClick = (e) => {
    e.stopPropagation();

    if (wasLongPress()) return;

    if (isOutOfStock && !allowNegativeStock) {
      toast.error("No stock for this product");
      return;
    }
    onAction(item, "add");
  };

  const handleImageError = (e) => {
    e.target.src = ProductPlaceholder;
  };

  return (
    <>
      <Grid item xs={12} className={styles.itemCard} {...longPressEvents} onClick={handleClick}>
        <Grid
          container
          className={`${styles.item} ${isInCart ? styles.itemSelected : ""} ${
            isOutOfStock && !allowNegativeStock ? styles.negativeStock : ""
          }`}
        >
          <div className={styles.left}>
            <img
              src={item?.image && item.image !== DEFAULT_PRODUCT_IMAGE ? item.image : ProductPlaceholder}
              alt=""
              className={styles.itemImage}
              onError={handleImageError}
            />
          </div>

          <div className={styles.itemInfo}>
            <h5>{formatName(item?.name)}</h5>
            <div className={styles.itemRate}>
              <div className={styles.rupeeIcon}>{selectedShop?.currency_symbol}</div>
              <div className={styles.itemPrice}>
                {roundOff(displayPrice)}/{item?.unit}
              </div>
            </div>

            <div className={styles.cartItemMeta}>
              {item?.type === PRODUCT_TYPE.SERVICE ? (
                <h6 className={styles.stockInfo}> </h6>
              ) : (
                <h6 className={styles.stockInfo}>
                  Stock :
                  {item?.unit === MEASURMENT_UNITS.PCS
                    ? quantityRoundOff(item?.stock ?? 0)
                    : roundOff(item?.stock ?? 0, 3, true)}
                </h6>
              )}

              <div className={styles.addButton}>
                {!productView ? (
                  <button className={styles.addBtn}>+</button>
                ) : (
                  <ArrowForwardIosIcon className={styles.arrow} />
                )}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default ItemView;
